import { render, staticRenderFns } from "./dev-left-sidebar.vue?vue&type=template&id=0edaccac"
import script from "./dev-left-sidebar.vue?vue&type=script&lang=js"
export * from "./dev-left-sidebar.vue?vue&type=script&lang=js"
import style0 from "./dev-left-sidebar.vue?vue&type=style&index=0&id=0edaccac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports